import { render, staticRenderFns } from "./ArvoreItem.vue?vue&type=template&id=8ad12750"
import script from "./ArvoreItem.vue?vue&type=script&lang=js"
export * from "./ArvoreItem.vue?vue&type=script&lang=js"
import style0 from "./ArvoreItem.vue?vue&type=style&index=0&id=8ad12750&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports